// TODO: Deprecated this Button component, please use the new button (button/v2) component from design system
// Prefix Primary == Newly designed Figma components
// Although verbose, the Primary prefix is intentionally kept in the filename to easily identify the newly 
// designed Figma components. This will help when we deprecate the older V0/Claude Code components.


import React from 'react';
import styles from './PrimaryActionButton.module.css';
import { cn } from '../../../lib/utils';

export interface PrimaryActionButtonProps {
  text: string;
  icon: React.ReactNode;
  iconPosition?: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'redirect' | 'gradient';
  title?: string;
}

const PrimaryActionButton: React.FC<PrimaryActionButtonProps> = ({
  text,
  icon,
  iconPosition = 'left',
  onClick,
  disabled = false,
  className = '',
  variant = 'default',
  title
}) => {
  const buttonClassName = cn(
    styles.button,
    disabled && styles.disabled,
    styles[variant],
    className
  );

  return (
    <button
      className={buttonClassName}
      onClick={onClick}
      disabled={disabled}
      type="button"
      title={title}
    >
      {iconPosition === 'left' && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{text}</span>
      {iconPosition === 'right' && <span className={styles.icon}>{icon}</span>}
    </button>
  );
};

export default PrimaryActionButton;